






































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import HTTP from "@/plugins/axios";
import { BoletoDTO, CardInfoDTO } from "@/interfaces/Boleto.interface";
import { BoletoDescuentoDTO } from "@/interfaces/DialogNewDescuentoBoleto.interface";
import { EventoDTO } from "@/interfaces/Evento.interface";
import LoginCortesias from "@/components/LoginCortesias.vue";
import CortesiasPanel from "@/components/CortesiasPanel.vue";
import moment from "moment";
moment.locale("es-MX");

@Component({
  components: {
    LoginCortesias,
    CortesiasPanel,
  },
})
export default class ViewVentaOficial extends Vue {
  private name: string = "ViewVentaOficial";
  private infoBoletos: BoletoDTO[] = [];
  private rateLimit: number = 5000;
  private step: string = "0";
  private finalizarLoading: boolean = false;
  private tabDisabled: any = {
    boletos: false,
    datos: true,
    pago: true,
    confirm: true,
  };
  private mainHost: string = process.env.VUE_APP_AXIOS_BASE_URL;
  private infoCortesias: any = null;
  private tarjetaError: boolean = false;
  private pagoNoCostFinalizar: boolean = false;
  private transaccionError: boolean = false;
  private transaccionErrorMSG: string =
    "Hubo un error al realizar la compra, por favor revise sus datos ó intentelo mas tarde.";
  private pagoError: boolean = false;
  private tarjetaErrorMSG: string =
    "Hubo un error al procesar la tarjeta, por favor revise sus datos ó intentelo mas tarde.";
  private infoBoletosVenta: any[] = [];
  private codigoDescuento: string = "";
  private evento: EventoDTO = null;
  private descuentoUsado: BoletoDescuentoDTO = null;
  private cardError: any = {
    number: {
      active: false,
      mensaje: "El numero de la tarjeta no es correcto.",
    },
    name: {
      active: false,
      mensaje: "El nombre del tarjetahabiente es incorrecto o esta vacio.",
    },
    exp: {
      active: false,
      mensaje: "La fecha de expiración es incorrecta.",
    },
    cvc: {
      active: false,
      mensaje: "El codigo CVC de la tarjeta es incorrecto.",
    },
  };
  private infoError: any = {
    nombre: {
      active: false,
      mensaje: "El nombre es obligatorio.",
    },
    phone: {
      active: false,
      mensaje: "El telefono es obligatorio.",
    },
    phone_must: {
      active: false,
      mensaje: "El telefono es obligatorio.",
    },
    phone_length: {
      active: false,
      mensaje: "El telefono debe tener 10 digitos.",
    },
    email: {
      active: false,
      mensaje: "El correo es obligatorio.",
    },
    emailConfirm: {
      active: false,
      mensaje: "Los campos no coinciden",
    },
  };
  private Config: any = {
    isDev: true,
    publicKey: "",
  };

  private ConfigBloqueo: any = {
    blockoxxo: null,
    blockshop: null,
  };
  private folioVenta: number = 0;
  private pdfUrl: string = "";
  private checkTerminos: boolean = false;
  private noSell: boolean = false;

  private codigoDescuentoError: any = {
    active: false,
    mensaje: "El codigo no es valido o ya expiro.",
  };
  private Descuentos: BoletoDescuentoDTO[] = [];
  private cardInfo: CardInfoDTO = {
    number: "",
    name: "",
    exp_year: "",
    exp_month: "",
    cvc: "",
    address: {
      street1: "Calle 123 Int 404",
      street2: "Col. Condesa",
      city: "Ciudad de Mexico",
      state: "Distrito Federal",
      zip: "12345",
      country: "MX",
    },
  };

  private datosVenta: any = {
    nombre: "",
    phone: "",
    email: "",
    emailConfirm: "",
    type: "card",
    token_id: null,
    descuento: null,
    people: [],
  };

  private paises: any = [
    {
      text: "Pais",
      value: "",
    },
    {
      text: "México",
      value: "MX",
    },
    {
      text: "Afghanistan",
      value: "AF",
    },
    {
      text: "Åland Islands",
      value: "AX",
    },
    {
      text: "Albania",
      value: "AL",
    },
    {
      text: "Algeria",
      value: "DZ",
    },
    {
      text: "American Samoa",
      value: "AS",
    },
    {
      text: "Andorra",
      value: "AD",
    },
    {
      text: "Angola",
      value: "AO",
    },
    {
      text: "Anguilla",
      value: "AI",
    },
    {
      text: "Antarctica",
      value: "AQ",
    },
    {
      text: "Antigua and Barbuda",
      value: "AG",
    },
    {
      text: "Argentina",
      value: "AR",
    },
    {
      text: "Armenia",
      value: "AM",
    },
    {
      text: "Aruba",
      value: "AW",
    },
    {
      text: "Australia",
      value: "AU",
    },
    {
      text: "Austria",
      value: "AT",
    },
    {
      text: "Azerbaijan",
      value: "AZ",
    },
    {
      text: "Bahamas",
      value: "BS",
    },
    {
      text: "Bahrain",
      value: "BH",
    },
    {
      text: "Bangladesh",
      value: "BD",
    },
    {
      text: "Barbados",
      value: "BB",
    },
    {
      text: "Belarus",
      value: "BY",
    },
    {
      text: "Belgium",
      value: "BE",
    },
    {
      text: "Belize",
      value: "BZ",
    },
    {
      text: "Benin",
      value: "BJ",
    },
    {
      text: "Bermuda",
      value: "BM",
    },
    {
      text: "Bhutan",
      value: "BT",
    },
    {
      text: "Bolivia",
      value: "BO",
    },
    {
      text: "Bonaire, Sint Eustatius and Saba",
      value: "BQ",
    },
    {
      text: "Bosnia and Herzegovina",
      value: "BA",
    },
    {
      text: "Botswana",
      value: "BW",
    },
    {
      text: "Bouvet Island",
      value: "BV",
    },
    {
      text: "Brazil",
      value: "BR",
    },
    {
      text: "British Indian Ocean Territory",
      value: "IO",
    },
    {
      text: "Brunei Darussalam",
      value: "BN",
    },
    {
      text: "Bulgaria",
      value: "BG",
    },
    {
      text: "Burkina Faso",
      value: "BF",
    },
    {
      text: "Burundi",
      value: "BI",
    },
    {
      text: "Cape Verde",
      value: "CV",
    },
    {
      text: "Cambodia",
      value: "KH",
    },
    {
      text: "Cameroon",
      value: "CM",
    },
    {
      text: "Canada",
      value: "CA",
    },
    {
      text: "Cayman Islands",
      value: "KY",
    },
    {
      text: "Central African Republic",
      value: "CF",
    },
    {
      text: "Chad",
      value: "TD",
    },
    {
      text: "Chile",
      value: "CL",
    },
    {
      text: "China",
      value: "CN",
    },
    {
      text: "Christmas Island",
      value: "CX",
    },
    {
      text: "Cocos (Keeling) Islands",
      value: "CC",
    },
    {
      text: "Colombia",
      value: "CO",
    },
    {
      text: "Comoros",
      value: "KM",
    },
    {
      text: "Republic of the Congo",
      value: "CG",
    },
    {
      text: "Democratic Republic of the Congo",
      value: "CD",
    },
    {
      text: "Cook Islands",
      value: "CK",
    },
    {
      text: "Costa Rica",
      value: "CR",
    },
    {
      text: "Ivory Coast",
      value: "CI",
    },
    {
      text: "Croatia",
      value: "HR",
    },
    {
      text: "Cuba",
      value: "CU",
    },
    {
      text: "Curaçao",
      value: "CW",
    },
    {
      text: "Cyprus",
      value: "CY",
    },
    {
      text: "Czech Republic",
      value: "CZ",
    },
    {
      text: "Denmark",
      value: "DK",
    },
    {
      text: "Djibouti",
      value: "DJ",
    },
    {
      text: "Dominica",
      value: "DM",
    },
    {
      text: "Dominican Republic",
      value: "DO",
    },
    {
      text: "Ecuador",
      value: "EC",
    },
    {
      text: "Egypt",
      value: "EG",
    },
    {
      text: "El Salvador",
      value: "SV",
    },
    {
      text: "Equatorial Guinea",
      value: "GQ",
    },
    {
      text: "Eritrea",
      value: "ER",
    },
    {
      text: "Estonia",
      value: "EE",
    },
    {
      text: "Ethiopia",
      value: "ET",
    },
    {
      text: "Falkland Islands (Malvinas)",
      value: "FK",
    },
    {
      text: "Faroe Islands",
      value: "FO",
    },
    {
      text: "Fiji",
      value: "FJ",
    },
    {
      text: "Finland",
      value: "FI",
    },
    {
      text: "France",
      value: "FR",
    },
    {
      text: "French Guiana",
      value: "GF",
    },
    {
      text: "French Polynesia",
      value: "PF",
    },
    {
      text: "French Southern and Antarctic Lands",
      value: "TF",
    },
    {
      text: "Gabon",
      value: "GA",
    },
    {
      text: "Gambia",
      value: "GM",
    },
    {
      text: "Georgia",
      value: "GE",
    },
    {
      text: "Germany",
      value: "DE",
    },
    {
      text: "Ghana",
      value: "GH",
    },
    {
      text: "Gibraltar",
      value: "GI",
    },
    {
      text: "Greece",
      value: "GR",
    },
    {
      text: "Greenland",
      value: "GL",
    },
    {
      text: "Grenada",
      value: "GD",
    },
    {
      text: "Guadeloupe",
      value: "GP",
    },
    {
      text: "Guam",
      value: "GU",
    },
    {
      text: "Guatemala",
      value: "GT",
    },
    {
      text: "Guernsey",
      value: "GG",
    },
    {
      text: "Guinea Guinea",
      value: "GN",
    },
    {
      text: "Guinea-Bissau",
      value: "GW",
    },
    {
      text: "Guyana",
      value: "GY",
    },
    {
      text: "Haiti",
      value: "HT",
    },
    {
      text: "Heard Island and McDonald Islands",
      value: "HM",
    },
    {
      text: "Vatican City",
      value: "VA",
    },
    {
      text: "Honduras",
      value: "HN",
    },
    {
      text: "Hong Kong",
      value: "HK",
    },
    {
      text: "Hungary",
      value: "HU",
    },
    {
      text: "Iceland",
      value: "IS",
    },
    {
      text: "India",
      value: "IN",
    },
    {
      text: "Indonesia",
      value: "ID",
    },
    {
      text: "Iran",
      value: "IR",
    },
    {
      text: "Iraq",
      value: "IQ",
    },
    {
      text: "Republic of Ireland",
      value: "IE",
    },
    {
      text: "Isle of Man",
      value: "IM",
    },
    {
      text: "Israel",
      value: "IL",
    },
    {
      text: "Italy",
      value: "IT",
    },
    {
      text: "Jamaica",
      value: "JM",
    },
    {
      text: "Japan",
      value: "JP",
    },
    {
      text: "Jersey",
      value: "JE",
    },
    {
      text: "Jordan",
      value: "JO",
    },
    {
      text: "Kazakhstan",
      value: "KZ",
    },
    {
      text: "Kenya",
      value: "KE",
    },
    {
      text: "Kiribati",
      value: "KI",
    },
    {
      text: "North Korea",
      value: "KP",
    },
    {
      text: "South Korea",
      value: "KR",
    },
    {
      text: "Kuwait",
      value: "KW",
    },
    {
      text: "Kyrgyzstan",
      value: "KG",
    },
    {
      text: "Lao Peoples Democratic Republic",
      value: "LA",
    },
    {
      text: "Latvia",
      value: "LV",
    },
    {
      text: "Lebanon",
      value: "LB",
    },
    {
      text: "Lesotho",
      value: "LS",
    },
    {
      text: "Liberia",
      value: "LR",
    },
    {
      text: "Libya",
      value: "LY",
    },
    {
      text: "Liechtenstein",
      value: "LI",
    },
    {
      text: "Lithuania",
      value: "LT",
    },
    {
      text: "Luxembourg",
      value: "LU",
    },
    {
      text: "Macau",
      value: "MO",
    },
    {
      text: "Republic of Macedonia",
      value: "MK",
    },
    {
      text: "Madagascar",
      value: "MG",
    },
    {
      text: "Malawi",
      value: "MW",
    },
    {
      text: "Malaysia",
      value: "MY",
    },
    {
      text: "Maldives",
      value: "MV",
    },
    {
      text: "Mali",
      value: "ML",
    },
    {
      text: "Malta",
      value: "MT",
    },
    {
      text: "Marshall Islands",
      value: "MH",
    },
    {
      text: "Martinique",
      value: "MQ",
    },
    {
      text: "Mauritania",
      value: "MR",
    },
    {
      text: "Mauritius",
      value: "MU",
    },
    {
      text: "Mayotte",
      value: "YT",
    },
    {
      text: "Federated States of Micronesia",
      value: "FM",
    },
    {
      text: "Moldova (Republic of)",
      value: "MD",
    },
    {
      text: "Monaco",
      value: "MC",
    },
    {
      text: "Mongolia",
      value: "MN",
    },
    {
      text: "Montenegro",
      value: "ME",
    },
    {
      text: "Montserrat",
      value: "MS",
    },
    {
      text: "Morocco",
      value: "MA",
    },
    {
      text: "Mozambique",
      value: "MZ",
    },
    {
      text: "Myanmar",
      value: "MM",
    },
    {
      text: "Namibia",
      value: "NA",
    },
    {
      text: "Nauru",
      value: "NR",
    },
    {
      text: "Nepal",
      value: "NP",
    },
    {
      text: "Netherlands",
      value: "NL",
    },
    {
      text: "New Caledonia",
      value: "NC",
    },
    {
      text: "New Zealand",
      value: "NZ",
    },
    {
      text: "Nicaragua",
      value: "NI",
    },
    {
      text: "Niger",
      value: "NE",
    },
    {
      text: "Nigeria",
      value: "NG",
    },
    {
      text: "Niue",
      value: "NU",
    },
    {
      text: "Norfolk Island",
      value: "NF",
    },
    {
      text: "Northern Mariana Islands",
      value: "MP",
    },
    {
      text: "Norway",
      value: "NO",
    },
    {
      text: "Oman",
      value: "OM",
    },
    {
      text: "Pakistan",
      value: "PK",
    },
    {
      text: "Palau",
      value: "PW",
    },
    {
      text: "State of Palestine",
      value: "PS",
    },
    {
      text: "Panama",
      value: "PA",
    },
    {
      text: "Papua New Guinea",
      value: "PG",
    },
    {
      text: "Paraguay",
      value: "PY",
    },
    {
      text: "Peru",
      value: "PE",
    },
    {
      text: "Philippines",
      value: "PH",
    },
    {
      text: "Pitcairn Islands",
      value: "PN",
    },
    {
      text: "Poland",
      value: "PL",
    },
    {
      text: "Portugal",
      value: "PT",
    },
    {
      text: "Puerto Rico",
      value: "PR",
    },
    {
      text: "Qatar",
      value: "QA",
    },
    {
      text: "Réunion",
      value: "RE",
    },
    {
      text: "Romania",
      value: "RO",
    },
    {
      text: "Russian Federation",
      value: "RU",
    },
    {
      text: "Rwanda",
      value: "RW",
    },
    {
      text: "Saint Barthélemy",
      value: "BL",
    },
    {
      text: "Saint Helena, Ascension and Tristan da Cunha",
      value: "SH",
    },
    {
      text: "Saint Kitts and Nevis",
      value: "KN",
    },
    {
      text: "Saint Lucia",
      value: "LC",
    },
    {
      text: "Saint Martin (French part)",
      value: "MF",
    },
    {
      text: "Saint Pierre and Miquelon",
      value: "PM",
    },
    {
      text: "Saint Vincent and the Grenadines",
      value: "VC",
    },
    {
      text: "Samoa",
      value: "WS",
    },
    {
      text: "San Marino",
      value: "SM",
    },
    {
      text: "Sao Tome and Principe",
      value: "ST",
    },
    {
      text: "Saudi Arabia",
      value: "SA",
    },
    {
      text: "Senegal",
      value: "SN",
    },
    {
      text: "Serbia",
      value: "RS",
    },
    {
      text: "Seychelles",
      value: "SC",
    },
    {
      text: "Sierra Leone",
      value: "SL",
    },
    {
      text: "Singapore",
      value: "SG",
    },
    {
      text: "Sint Maarten (Dutch part)",
      value: "SX",
    },
    {
      text: "Slovakia",
      value: "SK",
    },
    {
      text: "Slovenia",
      value: "SI",
    },
    {
      text: "Solomon Islands",
      value: "SB",
    },
    {
      text: "Somalia",
      value: "SO",
    },
    {
      text: "South Africa",
      value: "ZA",
    },
    {
      text: "South Georgia and the South Sandwich Islands",
      value: "GS",
    },
    {
      text: "South Sudan",
      value: "SS",
    },
    {
      text: "Spain",
      value: "ES",
    },
    {
      text: "Sri Lanka",
      value: "LK",
    },
    {
      text: "Sudan",
      value: "SD",
    },
    {
      text: "Suriname",
      value: "SR",
    },
    {
      text: "Svalbard and Jan Mayen",
      value: "SJ",
    },
    {
      text: "Swaziland",
      value: "SZ",
    },
    {
      text: "Sweden",
      value: "SE",
    },
    {
      text: "Switzerland",
      value: "CH",
    },
    {
      text: "Syrian Arab Republic",
      value: "SY",
    },
    {
      text: "Taiwan, Province of China",
      value: "TW",
    },
    {
      text: "Tajikistan",
      value: "TJ",
    },
    {
      text: "Tanzania",
      value: "TZ",
    },
    {
      text: "Thailand",
      value: "TH",
    },
    {
      text: "Timor-Leste",
      value: "TL",
    },
    {
      text: "Togo",
      value: "TG",
    },
    {
      text: "Tokelau",
      value: "TK",
    },
    {
      text: "Tonga",
      value: "TO",
    },
    {
      text: "Trinidad and Tobago",
      value: "TT",
    },
    {
      text: "Tunisia",
      value: "TN",
    },
    {
      text: "Turkey",
      value: "TR",
    },
    {
      text: "Turkmenistan",
      value: "TM",
    },
    {
      text: "Turks and Caicos Islands",
      value: "TC",
    },
    {
      text: "Tuvalu",
      value: "TV",
    },
    {
      text: "Uganda",
      value: "UG",
    },
    {
      text: "Ukraine",
      value: "UA",
    },
    {
      text: "United Arab Emirates",
      value: "AE",
    },
    {
      text: "United Kingdom of Great Britain and Northern Ireland",
      value: "GB",
    },
    {
      text: "United States of America",
      value: "US",
    },
    {
      text: "United States Minor Outlying Islands",
      value: "UM",
    },
    {
      text: "Uruguay",
      value: "UY",
    },
    {
      text: "Uzbekistan",
      value: "UZ",
    },
    {
      text: "Vanuatu",
      value: "VU",
    },
    {
      text: "Venezuela (Bolivarian Republic of)",
      value: "VE",
    },
    {
      text: "Vietnam",
      value: "VN",
    },
    {
      text: "Virgin Islands (British)",
      value: "VG",
    },
    {
      text: "Virgin Islands (U.S.)",
      value: "VI",
    },
    {
      text: "Wallis and Futuna",
      value: "WF",
    },
    {
      text: "Western Sahara",
      value: "EH",
    },
    {
      text: "Yemen",
      value: "YE",
    },
    {
      text: "Zambia",
      value: "ZM",
    },
    {
      text: "Zimbabwe",
      value: "ZW",
    },
  ];

  @Watch("step")
  private watchStep(v: string) {
    if (v === "1") {
      this.tabDisabled.datos = false;
    } else if (v === "2") {
      this.tabDisabled.pago = false;
    }
  }

  @Watch("Config")
  private watchConfig(v: any) {
    // @ts-ignore: Unreachable code error
    Conekta.setPublicKey(v.publicKey);
    console.log("Conekta :: ", v.publicKey);
    console.log("isDev :: ", v.isDev);
  }

  @Watch("descuentoUsado")
  private watchDescuentoUsado(v: BoletoDescuentoDTO) {
    this.datosVenta.descuento = v;
  }

  private addBoleto(item: BoletoDTO) {
    console.log("addBoleto :: ", item.id);
    if (item.quantity < 0) {
      item.quantity = 1;
    } else if (item.quantity < item.pendientes) {
      ++item.quantity;
    }
  }

  private lessBoleto(item: BoletoDTO) {
    console.log("lessBoleto :: ", item.id);
    if (item.quantity <= 1) {
      item.quantity = 0;
    } else {
      --item.quantity;
    }
  }

  private get totalVenta() {
    let res = 0;
    this.noSell = false;
    this.infoBoletos.forEach((boleto) => {
      res += boleto.quantity * boleto.cost;
    });

    if (this.descuentoUsado !== null) {
      if (this.descuentoUsado.descType === "%") {
        res = res - res * (this.descuentoUsado.descValue / 100);
      } else if (this.descuentoUsado.descType === "$") {
        res = res - this.descuentoUsado.descValue;
      }
    }

    res = Math.round(res * 100) / 100;
    if (res >= this.rateLimit) {
      this.noSell = true;
    }
    return res;
  }

  private get totalBoletos() {
    let res = 0;
    this.infoBoletos.forEach((boleto) => {
      res += boleto.quantity;
    });
    return res;
  }

  private get descuentoLabel() {
    let res = "";

    if (this.descuentoUsado !== null) {
      if (this.descuentoUsado.descType === "%") {
        console.log("descuentoLabel :: descType :: %");
        res = this.descuentoUsado.descValue + "%";
      } else if (this.descuentoUsado.descType === "$") {
        res = "$" + this.descuentoUsado.descValue + " MXN";
      }

      res = "Descuento (-" + res + ")";
    }

    return res;
  }

  private get checkBloqueo() {
    console.log("checkBloqueo :: ");
    let res = true;
    if (this.ConfigBloqueo.blockshop !== null) {
      console.log(
        moment().format("dddd, D MMMM YYYY") +
          " <= " +
          moment(this.ConfigBloqueo.blockshop).format("dddd, D MMMM YYYY")
      );
      if (moment() <= moment(this.ConfigBloqueo.blockshop)) {
        res = false;
      }
    }
    return res;
  }

  private get checkBloqueoOXXO() {
    console.log("checkBloqueoOXXO :: ");
    let res = true;
    if (this.ConfigBloqueo.blockoxxo !== null) {
      console.log(
        moment().format("dddd, D MMMM YYYY") +
          " <= " +
          moment(this.ConfigBloqueo.blockoxxo).format("dddd, D MMMM YYYY")
      );
      if (moment() <= moment(this.ConfigBloqueo.blockoxxo)) {
        res = false;
      }
    }
    return res;
  }

  private getBoletos() {
    HTTP.get("boleto/to-sell")
      .then((response) => {
        console.log("getBoletos :: response :: ", response.data);
        response.data.forEach((dat: any) => {
          dat.quantity = 0;
        });
        this.infoBoletos = response.data;
      })
      .catch((e) => {
        console.log("getBoletos :: catch :: ", e.response.data);
      })
      .finally();
  }

  private sendVenta() {
    this.infoBoletosVenta = [];
    this.transaccionError = false;

    this.infoBoletos.forEach((bole) => {
      if (bole.quantity > 0) {
        for (let i = 1; i <= bole.quantity; i++) {
          let boleto = Object.assign({}, bole);
          // eslint-disable-next-line
          boleto.inc = i;
          // boleto.cost = this.indCost(boleto.cost, 1, this.descuentoUsado)

          /* start: Nombre de los boletos */
          console.log(
            "NAME:",
            this.datosVenta.people[boleto.id + "-" + (i - 1)]
          );
          boleto.name = this.datosVenta.people[boleto.id + "-" + (i - 1)];
          /* start: Nombre de los boletos */

          this.infoBoletosVenta.push(boleto);
        }
      }
    });
    const data: any = {
      infoBoletosVenta: this.infoBoletosVenta,
      infoBoletos: this.infoBoletos,
      datosVenta: this.datosVenta,
    };

    console.log("sendVenta :: ", data);
    HTTP.post("conekta/", data)
      .then((response) => {
        console.log("sendVenta :: response :: ", response.data);
        if (response.data.success) {
          this.step = "3";
          this.tabDisabled.datos = true;
          this.tabDisabled.pago = true;
          this.tabDisabled.boletos = true;
          this.tabDisabled.confirm = false;
          this.folioVenta = response.data.folioventa;
          this.pdfUrl = response.data.pdf;
        }
      })
      .catch((e: any) => {
        console.log("sendVenta :: catch :: ", e.response);
        console.log("sendVenta :: catch :: ", e.response.data.message.type);
        console.log(
          "sendVenta :: catch :: ",
          e.response.data.message.err.details
        );
        this.transaccionError = true;
      })
      .finally(() => {
        this.finalizarLoading = false;
      });
  }

  private sendNoCost() {
    this.pagoError = false;
    this.pagoNoCostFinalizar = true;
    this.infoBoletosVenta = [];

    this.infoBoletos.forEach((bole) => {
      if (bole.quantity > 0) {
        for (let i = 1; i <= bole.quantity; i++) {
          let boleto: any = {};
          boleto = Object.assign({}, bole);
          boleto.inc = i;
          // boleto.cost = this.indCost(boleto.cost, 1, this.descuentoUsado)
          this.infoBoletosVenta.push(boleto);
        }
      }
    });
    const data: any = {
      infoBoletosVenta: this.infoBoletosVenta,
      infoBoletos: this.infoBoletos,
      datosVenta: this.datosVenta,
    };

    console.log("sendNoCost :: ", data);
    HTTP.post("conekta/no-cost", data)
      .then((response) => {
        console.log("sendNoCost :: response :: ", response.data);
        if (response.data.success) {
          this.step = "3";
          this.tabDisabled.datos = true;
          this.tabDisabled.pago = true;
          this.tabDisabled.boletos = true;
          this.tabDisabled.confirm = false;
          this.folioVenta = response.data.folioventa;
          this.pdfUrl = response.data.pdf;
        } else {
          this.pagoError = true;
        }
      })
      .catch((e: any) => {
        console.log("sendNoCost :: catch :: ", e.response.data);
      })
      .finally(() => {
        this.pagoNoCostFinalizar = false;
      });
  }

  private getDescuentos() {
    HTTP.get("descuento/only-valid")
      .then((response) => {
        console.log("getDescuentos :: response :: ", response.data);
        this.Descuentos = response.data;
      })
      .catch((e) => {
        console.log("getDescuentos :: catch :: ", e.response.data);
      })
      .finally();
  }

  private indCost(cost: any, quantity: any, desc: BoletoDescuentoDTO) {
    let res = cost * quantity;

    if (this.descuentoUsado !== null) {
      if (this.descuentoUsado.descType === "%") {
        res = res - res * (this.descuentoUsado.descValue / 100);
      }
    }

    res = Math.round(res * 100) / 100;
    return res;
  }

  private addDiscount(descuento: string) {
    const desc = this.Descuentos.find((d) => {
      return d.code === descuento;
    });

    if (desc === undefined) {
      this.codigoDescuentoError.active = true;
    } else {
      this.descuentoUsado = desc;
    }
  }

  private delDiscount() {
    this.descuentoUsado = null;
    this.codigoDescuentoError.active = false;
  }

  private step1() {
    if (this.totalBoletos > 0) {
      if (this.totalVenta > 0 && this.totalVenta < 3) {
        console.log(
          "El Monto minimo de compra es de $3.00 MXN :: ",
          this.totalVenta
        );
      } else {
        this.step = "1";
      }
    }
  }

  private randomName() {
    return Math.floor(Math.random() * (999999 - 1 + 1)) + 1;
  }

  private validateStep1() {
    this.infoError.nombre.active = false;
    this.infoError.email.active = false;
    this.infoError.emailConfirm.active = false;

    /* start: Validacion de boletos */
    let boletosCount = 0;
    for (const key in this.datosVenta.people) {
      if (Object.prototype.hasOwnProperty.call(this.datosVenta.people, key)) {
        const element = this.datosVenta.people[key];
        boletosCount++;
      }
    }

    if (this.totalBoletos !== boletosCount) {
      console.log(this.datosVenta.people);
      alert("Llene los datos de los asistentes");
      return;
    }

    if (this.totalBoletos === boletosCount) {
      for (const key in this.datosVenta.people) {
        if (Object.prototype.hasOwnProperty.call(this.datosVenta.people, key)) {
          const element = this.datosVenta.people[key];
          console.log("element", element);
          if (element === "") {
            alert("Llene los datos de los asistentes");
            return;
          }
        }
      }
    }
    /* end: Validacion de boletos */

    if (this.totalBoletos > 0) {
      if (this.datosVenta.nombre === "") {
        this.infoError.nombre.active = true;
      } else if (this.datosVenta.email === "") {
        this.infoError.email.active = true;
      } else if (
        this.datosVenta.emailConfirm === "" ||
        this.datosVenta.emailConfirm !== this.datosVenta.email
      ) {
        this.infoError.emailConfirm.active = true;
      } else if (this.datosVenta.phone === "") {
        this.infoError.phone.mensaje = this.infoError.phone_must.mensaje;
        this.infoError.phone.active = true;
      } else if (this.datosVenta.phone.length < 10) {
        this.infoError.phone.mensaje = this.infoError.phone_length.mensaje;
        this.infoError.phone.active = true;
      } else {
        console.log("this.totalVenta :: ", this.totalVenta);
        if (this.totalVenta > 0 && this.totalVenta < 3) {
          console.log(
            "El Monto minimo de compra es de $3.00 MXN :: ",
            this.totalVenta
          );
        } else if (this.totalVenta <= 0) {
          console.log("this.totalVenta <= 0 :: ", this.totalVenta);
          this.sendNoCost();
        } else {
          this.step = "2";
        }
      }
    }
  }

  private async validateCard(card: CardInfoDTO) {
    console.log("validateCard :: ", card);
    this.finalizarLoading = true;

    if (this.datosVenta.type === "card") {
      this.cardError.number.active = false;
      this.cardError.exp.active = false;
      this.cardError.cvc.active = false;

      // @ts-ignore: Unreachable code error
      if (!Conekta.card.validateNumber(card.number)) {
        console.log("Error card number");
        this.cardError.number.active = true;
        this.finalizarLoading = false;
        // @ts-ignore: Unreachable code error
      } else if (
        // @ts-ignore: Unreachable code error
        !Conekta.card.validateExpirationDate(card.exp_month, card.exp_year)
      ) {
        console.log("Error card validateExpirationDate");
        this.cardError.exp.active = true;
        this.finalizarLoading = false;
        // @ts-ignore: Unreachable code error
      } else if (!Conekta.card.validateCVC(card.cvc)) {
        console.log("Error card validateCVC");
        this.cardError.cvc.active = true;
        this.finalizarLoading = false;
      } else {
        console.log("Create Token :: ");
        // @ts-ignore: Unreachable code error
        await Conekta.Token.create(
          { card: this.cardInfo },
          (res: any) => {
            this.datosVenta.token_id = res.id;
            console.log("Res :: ", res);
            this.sendVenta();
          },
          (err: any) => {
            console.log("Err :: ", err);
            this.finalizarLoading = false;
            this.tarjetaError = true;
          }
        );
      }
    } else if (this.datosVenta.type === "oxxo_cash") {
      this.sendVenta();
    }
  }

  private FindEvento() {
    console.log("FindEvento :: ");
    HTTP.get("evento/to-sell")
      .then((response) => {
        console.log("FindEvento :: response :: ", response.data);
        this.evento = response.data;
      })
      .catch((e) => {
        console.log("FindEvento :: catch :: ", e.response.data);
      });
  }

  private gConfig() {
    console.log("gConfig :: ");
    HTTP.get("config/public-key")
      .then((response) => {
        console.log("gConfig :: response :: ", response.data);
        if (response.data.success) {
          this.Config = response.data.info;
        }
      })
      .catch((e) => {
        console.log("gConfig :: catch :: ", e.response.data);
      });
  }

  private gConfigBloqueo() {
    console.log("gConfig :: ");
    HTTP.get("config/bloqueo")
      .then((response) => {
        console.log("gConfigBloqueo :: response :: ", response.data);
        if (response.data.success) {
          this.ConfigBloqueo = response.data.info;
        }
      })
      .catch((e) => {
        console.log("gConfigBloqueo :: catch :: ", e.response.data);
      });
  }

  private gPDF(item: string) {
    console.log("gPDF :: ", item);
    window.open(
      process.env.VUE_APP_AXIOS_BASE_URL + "conekta/pdf/" + item,
      "_blank"
    );
  }

  private goTerminosCondiciones() {
    window.open(
      "https://www.expomoto.com.mx/terminos-y-condiciones/",
      "_blank"
    );
  }

  private goAvisodePrivacidad() {
    window.open("https://www.expomoto.com.mx/aviso-de-privacidad/", "_blank");
  }

  private goTerminosCondicionesConekta() {
    window.open("https://conekta.com/legal/tos", "_blank");
  }

  private beforeMount() {
    console.log("beforeMount :: ", this.name);
    this.gConfig();
    this.getBoletos();
    this.getDescuentos();
    this.FindEvento();
    this.gConfigBloqueo();
  }
}
